import { render, staticRenderFns } from "./TokenTransactionItem.vue?vue&type=template&id=707f587c&scoped=true&"
import script from "./TokenTransactionItem.vue?vue&type=script&lang=js&"
export * from "./TokenTransactionItem.vue?vue&type=script&lang=js&"
import style0 from "./TokenTransactionItem.vue?vue&type=style&index=0&id=707f587c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707f587c",
  null
  
)

export default component.exports